"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Util_1 = require("../../Util");
/**
 * A catch-all for keywords, that will either emit an error or ignore,
 * depending on whether or not the `errorOnInvalidIris` property is set.
 */


var EntryHandlerKeywordUnknownFallback =
/*#__PURE__*/
function () {
  function EntryHandlerKeywordUnknownFallback() {
    _classCallCheck(this, EntryHandlerKeywordUnknownFallback);
  }

  _createClass(EntryHandlerKeywordUnknownFallback, [{
    key: "isPropertyHandler",
    value: function isPropertyHandler() {
      return false;
    }
  }, {
    key: "validate",
    value: function () {
      var _validate = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(parsingContext, util, keys, depth, inProperty) {
        var key;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return util.unaliasKeyword(keys[depth], keys, depth);

              case 2:
                key = _context.sent;

                if (!Util_1.Util.isKeyword(key)) {
                  _context.next = 8;
                  break;
                }

                if (inProperty) {
                  _context.next = 7;
                  break;
                }

                if (!(key === '@list')) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return", false);

              case 7:
                return _context.abrupt("return", true);

              case 8:
                return _context.abrupt("return", false);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function validate(_x, _x2, _x3, _x4, _x5) {
        return _validate.apply(this, arguments);
      }

      return validate;
    }()
  }, {
    key: "test",
    value: function () {
      var _test = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(parsingContext, util, key, keys, depth) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", Util_1.Util.isKeyword(key));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function test(_x6, _x7, _x8, _x9, _x10) {
        return _test.apply(this, arguments);
      }

      return test;
    }()
  }, {
    key: "handle",
    value: function () {
      var _handle = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(parsingContext, util, key, keys, value, depth) {
        var keywordType;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                keywordType = EntryHandlerKeywordUnknownFallback.VALID_KEYWORDS_TYPES[key];

                if (keywordType !== undefined) {
                  if (keywordType && typeof value !== keywordType) {
                    parsingContext.emitError(new Error("Invalid value type for '".concat(key, "' with value '").concat(value, "'")));
                  }
                } else if (parsingContext.errorOnInvalidProperties) {
                  parsingContext.emitError(new Error("Unknown keyword '".concat(key, "' with value '").concat(value, "'")));
                }

                parsingContext.emittedStack[depth] = false;

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function handle(_x11, _x12, _x13, _x14, _x15, _x16) {
        return _handle.apply(this, arguments);
      }

      return handle;
    }()
  }]);

  return EntryHandlerKeywordUnknownFallback;
}();

EntryHandlerKeywordUnknownFallback.VALID_KEYWORDS_TYPES = {
  '@index': 'string',
  '@list': null,
  '@reverse': 'object',
  '@set': null,
  '@value': null
};
exports.EntryHandlerKeywordUnknownFallback = EntryHandlerKeywordUnknownFallback;